import script from "./AddUserForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AddUserForm.vue?vue&type=script&setup=true&lang=js"

import "./AddUserForm.vue?vue&type=style&index=0&id=021cf0a3&scoped=true&lang=css"
import "./AddUserForm.vue?vue&type=style&index=1&id=021cf0a3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-021cf0a3"]])

export default __exports__